module.exports = __webpack_public_path__ + "static/media/arrorw1.2ecb90d9.svg";